<template>
  <v-row v-if="!block" class="form-field">
    <v-col cols="4" class="d-flex align-center">
      <span data-testid="field_label">{{ label }}</span>
      <span v-if="required" class="red--text">*</span>
    </v-col>
    <v-col cols="8">
      <slot/>
    </v-col>
  </v-row>
  <div v-else class="form-field form-field--block">
    <div class="form-field__label">
      <span data-testid="field_label">{{ label }}</span>
      <span v-if="required" class="red--text">*</span>
    </div>
    <div class="form-field__input">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'form-field',
  props: {
    label: {
      type: String,
      required: true,
    },
    required: Boolean,
    block: Boolean,
  },
};
</script>

<style scoped lang="sass">
.form-field
  ::v-deep .v-text-field__details
    margin-bottom: -10px !important

.form-field--block
  margin-bottom: 12px

.form-field__label
  font-size: 14px
  margin-bottom: 4px

.form-field__input
  width: 100%
</style>
